import NewUserForm from './NewUserFom'

export default NewUserForm
